<h1 class="text-white text-lg font-semibold mb-4">Configuración General</h1>
<form [formGroup]="generalSettingsForm" (ngSubmit)="onSubmit()">
<div class="p-6 rounded-lg shadow-md bg-gray-800 text-white">
    <h2 class="text-xl font-bold mb-4">Parámetros de IVA</h2>
    <div class="mb-6 flex gap-5">
        <mat-form-field floatLabel="always" class="flex-1">
            <mat-label>Porcentaje de IVA (%)</mat-label>
            <input matInput type="number" formControlName="ivaRate" placeholder="Ej: 12" [readonly]="!(canUpdateGeneralSettings$ | async)">
            <mat-error *ngIf="generalSettingsForm.get('ivaRate')?.invalid && (generalSettingsForm.get('ivaRate')?.dirty || generalSettingsForm.get('ivaRate')?.touched)">
                <span *ngIf="generalSettingsForm.get('ivaRate')?.errors?.['required']">Requerido.</span>
                <span *ngIf="generalSettingsForm.get('ivaRate')?.errors?.['min']">Debe ser no negativo.</span>
            </mat-error>
        </mat-form-field>
    </div>

    <h2 class="text-xl font-bold mb-4">Reglas de Impuesto sobre la Renta (ISR)</h2>
    <p class="mb-4">
        Defina las diferentes reglas para la aplicación del Descuento de Impuestos ISR.<br>
        Las reglas se aplicarán según la cuota mínima de pasajes (sin impuestos) que un Cliente debe alcanzar.
    </p>
        <div formArrayName="isrRules" class="mb-6">
            <div *ngFor="let ruleGroup of isrRulesArray.controls; let i = index" [formGroupName]="i" class="mb-4 p-4 border rounded-md">
                <div class="flex gap-5">
                    <mat-form-field floatLabel="always" class="flex-1">
                        <mat-label>Cuota Mínima (Q)</mat-label>
                        <input matInput type="number" formControlName="minQuota" placeholder="Ej: 2500" [readonly]="!(canUpdateGeneralSettings$ | async)">
                        <mat-error *ngIf="ruleGroup.get('minQuota')?.invalid && (ruleGroup.get('minQuota')?.dirty || ruleGroup.get('minQuota')?.touched)">
                            <span *ngIf="ruleGroup.get('minQuota')?.errors?.['required']">Requerida.</span>
                            <span *ngIf="ruleGroup.get('minQuota')?.errors?.['min']">Debe ser no negativa.</span>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field floatLabel="always" class="flex-1">
                        <mat-label>Porcentaje (%)</mat-label>
                        <input matInput type="number" formControlName="percentage" placeholder="Ej: 5" [readonly]="!(canUpdateGeneralSettings$ | async)">
                        <mat-error *ngIf="ruleGroup.get('percentage')?.invalid && (ruleGroup.get('percentage')?.dirty || ruleGroup.get('percentage')?.touched)">
                            <span *ngIf="ruleGroup.get('percentage')?.errors?.['required']">Requerido.</span>
                            <span *ngIf="ruleGroup.get('percentage')?.errors?.['min']">Debe ser no negativo.</span>
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field floatLabel="always" class="flex-1">
                        <mat-label>Descuento Fijo (Q)</mat-label>
                        <input matInput type="number" formControlName="fixedDiscount" placeholder="Ej: 1500" [readonly]="!(canUpdateGeneralSettings$ | async)">
                        <mat-error *ngIf="ruleGroup.get('fixedDiscount')?.invalid && (ruleGroup.get('fixedDiscount')?.dirty || ruleGroup.get('fixedDiscount')?.touched)">
                            <span *ngIf="ruleGroup.get('fixedDiscount')?.errors?.['required']">Requerido.</span>
                            <span *ngIf="ruleGroup.get('fixedDiscount')?.errors?.['min']">Debe ser no negativo.</span>
                        </mat-error>
                    </mat-form-field>
                    <div>
                        <mat-label class="text-gray text-12">Calcular Porcentaje sobre Excedente de Cuota</mat-label>
                        <div>
                            <mat-slide-toggle formControlName="subtractMinQuotaForExcess" [disabled]="!(canUpdateGeneralSettings$ | async)" class="flex-1"></mat-slide-toggle>
                        </div>
                    </div>
                    <button mat-icon-button color="warn" (click)="removeISRRule(i)" [disabled]="!(canUpdateGeneralSettings$ | async)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="canUpdateGeneralSettings$ | async" class="mt-4">
                <button matButton type="button" (click)="addISRRule()">
                    <mat-icon>add</mat-icon> Añadir Regla ISR
                </button>
            </div>
        </div>
</div>

<div class="p-6 rounded-lg shadow-md bg-gray-800 text-white mt-6">
    <h2 class="text-xl font-bold mb-4">Reglas de Retención de IVA</h2>
    <p class="mb-4">
        Configure los umbrales de pasajes y el porcentaje de retención que se aplicará sobre el IVA calculado.
    </p>
    <div formArrayName="retentionIVARules" class="mb-6">
        <div *ngFor="let ruleGroup of retentionIVARulesArray.controls; let i = index" [formGroupName]="i" class="mb-4 p-4 border rounded-md">
            <div class="flex gap-5 items-center">
                <mat-form-field floatLabel="always" class="flex-1">
                    <mat-label>Pasajes mínimos (Q)</mat-label>
                    <input matInput type="number" formControlName="minPassages" placeholder="Ej: 2500" [readonly]="!(canUpdateGeneralSettings$ | async)">
                    <mat-error *ngIf="ruleGroup.get('minPassages')?.invalid && (ruleGroup.get('minPassages')?.dirty || ruleGroup.get('minPassages')?.touched)">
                        <span *ngIf="ruleGroup.get('minPassages')?.errors?.['required']">Requerido.</span>
                        <span *ngIf="ruleGroup.get('minPassages')?.errors?.['min']">Debe ser no negativo.</span>
                    </mat-error>
                </mat-form-field>
                <mat-form-field floatLabel="always" class="flex-1">
                    <mat-label>Porcentaje de retención (%)</mat-label>
                    <input matInput type="number" formControlName="retentionPct" placeholder="Ej: 15" [readonly]="!(canUpdateGeneralSettings$ | async)">
                    <mat-error *ngIf="ruleGroup.get('retentionPct')?.invalid && (ruleGroup.get('retentionPct')?.dirty || ruleGroup.get('retentionPct')?.touched)">
                        <span *ngIf="ruleGroup.get('retentionPct')?.errors?.['required']">Requerido.</span>
                        <span *ngIf="ruleGroup.get('retentionPct')?.errors?.['min']">Debe ser no negativo.</span>
                    </mat-error>
                </mat-form-field>
                <button mat-icon-button color="warn" (click)="removeRetentionIVARule(i)" [disabled]="!(canUpdateGeneralSettings$ | async)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
        <div *ngIf="canUpdateGeneralSettings$ | async" class="mt-4">
            <button matButton type="button" (click)="addRetentionIVARule()">
                <mat-icon>add</mat-icon> Añadir Regla de Retención
            </button>
        </div>
    </div>
</div>
<div *ngIf="canUpdateGeneralSettings$ | async" class="mt-6">
    <button matButton type="submit" [disabled]="generalSettingsForm.invalid">Guardar Configuración</button>
</div>
<div *ngIf="!(canUpdateGeneralSettings$ | async)" class="mt-4 p-3 bg-yellow-700 text-yellow-100 rounded">
    No tienes permisos para modificar esta configuración.
</div>
</form>
